import UploadedData from './UploadedData'
export default UploadedData